module.exports = __webpack_public_path__ + "img/10.9d5207dd.png";